import axios from 'axios';
import React, { useEffect, useState } from 'react';
import LineIcon from 'react-lineicons';
import { Link, NavLink } from 'react-router-dom';

function Header() {
    const [information, setInformation] = useState("");
    const [navigationToggler, setNavigationToggler] = useState(false);

    const handleNavigationToggler = () => {
        setNavigationToggler(!navigationToggler);
    }

    useEffect(() => {
        axios.get('/api/information')
            .then(response => {
                setInformation(response.data);
            })
    }, [])

    return (
        <nav className={navigationToggler ? "mi-header is-visible" : "mi-header"}>
            <button onClick={handleNavigationToggler} className="mi-header-toggler">
                {!navigationToggler ? <LineIcon name="menu" /> : <LineIcon name="close" />}
            </button>
            <div className="mi-header-inner">
                <div className="mi-header-image">
                    <Link to="/">
                        <img src={information.brandImage} alt="brandimage" />
                    </Link>
                </div>

                <ul className="mi-header-menu">
                <li><NavLink exact to="/"><span>HOME</span></NavLink></li>
                    <li><NavLink to="/sobre"><span>SOBRE</span></NavLink></li>
                    <li><NavLink to="/curriculo"><span>CURRÍCULO</span></NavLink></li>
                    <li><NavLink to="/portfolios"><span>PORTFÓLIO</span></NavLink></li>
                    <li><NavLink to="/blog"><span>BLOG</span></NavLink></li>
                    <li><NavLink to="/contato"><span>CONTATO</span></NavLink></li>
                </ul>
                
                <p className="mi-header-copyright">&copy; {new Date().getFullYear()} <b><a rel="noopener noreferrer" target="_blank" href="https://rgssoftwarebr.com.br">RGSSoftwareBr</a></b></p>
            </div>
        </nav>
    )
}


export default Header;